import { render, staticRenderFns } from "./SavedBuilds.vue?vue&type=template&id=62b2bd77"
import script from "./SavedBuilds.vue?vue&type=script&lang=js"
export * from "./SavedBuilds.vue?vue&type=script&lang=js"
import style0 from "./SavedBuilds.vue?vue&type=style&index=0&id=62b2bd77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports